import type { IntestacyRuleSet } from "./types.js";

// VIC intestacy ruleset — Administration and Probate Act 1958 (Vic), Part IA
// (intestacy provisions ss 70A–70ZK, as amended by the Administration and
// Probate and Other Acts Amendment (Succession and Related Matters) Act 2017,
// in force from 1 Nov 2017).
//
// Distribution hierarchy (cited):
//   s 70J  — partner, and issue ALL of the partner (or no issue) → partner takes
//             the WHOLE residuary estate.
//   s 70M  — partner + issue NOT all of that partner → partner takes: personal
//             chattels + the STATUTORY LEGACY (s 70M, CPI-indexed each 1 July) +
//             interest + ONE HALF of the balance; the issue take the other half.
//   no partner → issue take all; else parents; else siblings; else
//             grandparents/aunts/uncles; else the Crown.
//
// Statutory legacy: the partner's "statutory legacy" is calculated under s 70M
// and DECLARED under s 70N, gazetted annually and effective 1 July (CPI-indexed,
// Melbourne all-groups). PRIMARY source for the current figure: Victoria
// Government Gazette No. G26 (declaration under s 70N), which sets the legacy at
// $573,640 on and from 1 Jul 2025. Corroborated by nationalprobate.com.au/vic
// (verified 2026-06-23). Figures:
//   1 Jul 2025 – 30 Jun 2026 : $573,640.00   (current — Gazette G26)
//   1 Jul 2024 – 30 Jun 2025 : $559,660.00
//   1 Jul 2023 – 30 Jun 2024 : $539,100.00
//   1 Jul 2022 – 30 Jun 2023 : $499,210.00
export const vic: IntestacyRuleSet = {
  state: "VIC",
  act: "Administration and Probate Act 1958 (Vic)",
  distributionRef: "Pt IA ss 70J, 70M",
  sources: {
    act: "https://www.legislation.vic.gov.au/in-force/acts/administration-and-probate-act-1958",
    s70m: "https://www.legislation.vic.gov.au/in-force/acts/administration-and-probate-act-1958",
    statutoryLegacy:
      "https://www.gazette.vic.gov.au/ (Victoria Government Gazette G26, s 70N declaration) — corroborated: https://www.nationalprobate.com.au/vic/statutory-legacy",
    plainEnglish:
      "https://www.lawreform.vic.gov.au/publication/succession-laws-report/5-intestacy/",
  },
  sourcesVerifiedAt: "2026-06-23",
  statutoryLegacy: [
    {
      effectiveFrom: "2025-07-01",
      effectiveTo: "2026-06-30",
      amount: 573_640.0,
      source:
        "Victoria Government Gazette G26 (s 70N declaration) — https://www.gazette.vic.gov.au/",
    },
    {
      effectiveFrom: "2024-07-01",
      effectiveTo: "2025-06-30",
      amount: 559_660.0,
      source: "https://www.nationalprobate.com.au/vic/statutory-legacy",
    },
    {
      effectiveFrom: "2023-07-01",
      effectiveTo: "2024-06-30",
      amount: 539_100.0,
      source: "https://www.nationalprobate.com.au/vic/statutory-legacy",
    },
    {
      effectiveFrom: "2022-07-01",
      effectiveTo: "2023-06-30",
      amount: 499_210.0,
      source: "https://www.nationalprobate.com.au/vic/statutory-legacy",
    },
  ],
  // s 70M: partner takes one-half of the balance when issue are not all the partner's.
  partnerResidueShare: 0.5,
  partnerResidueShareOneChild: null,
  // s 70J: where issue are all the partner's (or no issue), the partner takes all.
  partnerTakesAllWhenAllShared: true,
};
